/* eslint-disable no-undefined */
import { TableSearch } from "../../../components/Table/TableActions";
import NotFounditem from "../../error/NotFound";
import nosearch from "../../../assets/images/no-search.svg";
import { httprequest } from "../../../data/api";
import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import PageLoader from "../../../components/PageLoader";
import Modal from "../../../components/Modal";
import { toast } from "react-toastify";
import useStyles from "../styles";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import useValidator from "../../../hooks/useValidator";
// import { Grade } from "../../../utils/DropDown";
import ButtonCount from "../../../components/ButtonCount";
import { useUserState } from "../../../context/UserContext";
import useWindowSize from "../../../hooks/useWindow";
import BulkSingleSubjectResultEntry from "../../classes/admin/BulkSingleSubjectResult";

const CLASSES_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const GET_A_SUBJECT = "/api/v1/subjects/";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_SUBJECT_GRADES = "/api/v1/grade/";
const GRADING_SYSTEM = "/api/v1/grading-system";
const TEACHER_SUBJECT = "/api/v1/teacher/class-subject/";
const CLASS_TEST_RESULT = "/api/v1/ca-test/result/";
const CLASS_EXAM_RESULT = "/api/v1/school-exams/result/";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const CLASS_STUDENT_ENDPOINT = "/api/v1/students";

// --| Dummy Data
// import StudentReportData from "../../../dummy_data/studentReportData.json";

const SubjectResultDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const { userRole } = useUserState();
  const navigate = useNavigate();
  const [obtainablescore, setObtainableScore] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [value, setValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [addsubjectModal, setSubjectModal] = useState(false);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [classDetail, setClassDetail] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [classGrades, setClassGrades] = useState([]);
  const [caErrors, setCaErrors] = useState({});
  const [resultCreating, setResultCreating] = useState(false);
  const [resultEditing, setResultEditing] = useState(false);
  const [resultDeleting, setResultDeleting] = useState(false);
  const [aSubjectDetail, setASubjectDetail] = useState([]);
  const [allGradingSystem, setAllGradingSystem] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [editselectedGrade, setEditSelectedGrade] = useState([]);
  const [calculatedGrade, setCalculatedGrade] = useState(null);
  const [editcalculatedGrade, setEditCalculatedGrade] = useState(null);
  const [filterStatus, setFilterStatus] = useState("");
  const [editResultModal, setEditResultModal] = useState(false);
  const [autoCA, setAutoCA] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [classTestResult, setClassTestResult] = useState([]);
  const [classExamResult, setClassExamResult] = useState([]);
  const [classStudents, setClassStudents] = useState([]);
  const [studentResultValidator, showStudentResultValidator] = useValidator();
  const [editstudentResultValidator, showEditStudentResultValidator] = useValidator();
  const location = useLocation();
  const isTeacher = userRole?.role_type === "employee";

  const width = useWindowSize();
  const mobile = width < 600;
  // Extract "type" from the query string
  const queryParams = new URLSearchParams(location.search);
  const class_id = { classId: queryParams.get("class_id") };
  const ClassID = class_id?.classId;

  const subjectStudents = Array.from(
    new Map(
      (classGrades || [])
        .map((res) => {
          const s = res?.student || {};
          const id = s?.student_id || s?.id;
          const name = `${s?.last_name || ""} ${s?.first_name || ""}`.trim();

          return [
            id,
            {
              student_id: id,
              first_name: s?.first_name,
              last_name: s?.last_name,
              name
            }
          ];
        })
    ).values()
  );

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const [subjectForm, setSubjectForm] = useState({
    subject_id: id,
    class_id: ClassID,
    student_id: "",
    CA_scores: {},
    term_id: "",
    grade: "",
    grading_system_id: "",
    total: "",
    exam_score: 0,
    CA_total: "",
    grade_type: "manual"
  });

  const [editsubjectForm, setEditSubjectForm] = useState({
    subject_id: id,
    class_id: ClassID,
    student_id: "",
    CA_scores: {},
    grade: "",
    total: "",
    grading_system: "",
    exam_score: 0,
    CA_total: "",
    grade_type: ""
  });

  const handleEditResultModal = (row) => {
    setCurrentRow(row);
    setEditResultModal(true);
    setEditSubjectForm({
      ...editsubjectForm,
      subject_id: id,
      class_id: ClassID,
      student_id: row?.student?.id,
      CA_scores: row?.CA_scores,
      grade: row?.grade,
      total: row?.total,
      exam_score: row?.exam_score,
      CA_total: row?.CA_total,
      grading_system: row?.grading_system,
      grade_type: row?.grade_type
    });
    setEditSelectedGrade(row?.grading_system);
  };

  const handleCloseAddResultModal = () => {
    setSubjectModal(false);
    setAutoCA(false);

    const initialCA = (obtainablescore?.[0]?.ca || []).reduce((acc, item) => {
      acc[item?.ca_type] = "";

      return acc;
    }, {});

    setSubjectForm((prev) => ({
      ...prev,
      CA_scores: initialCA,
      CA_total: "",
      grade: "",
      grading_system_id: "",
      total: "",
      exam_score: 0,
      student_id: ""
    }));
    setCaErrors({});
  };

  const handleCloseEditResultModal = () => {
    setEditResultModal(!editResultModal);
    setEditSelectedGrade([]);
  };

  // CA SCores Input
  const handleTestScoreChange = (e, caType) => {
    const inputRaw = e.target.value;

    // Remove leading zeros: "010" -> "10"
    const inputValue = inputRaw.replace(/^0+(?=\d)/, "");

    // Get max obtainable for this caType
    const maxObtainable = obtainablescore?.[0]?.ca?.find((item) => item.ca_type === caType)?.score || 0;

    if (Number(inputValue) > maxObtainable) {
      setCaErrors((prev) => ({
        ...prev,
        [caType]: `${caType} cannot exceed ${maxObtainable}`
      }));

      return;
    } else {
    // Clear error for this CA type
      setCaErrors((prev) => ({
        ...prev,
        [caType]: ""
      }));
    }

    // Update CA_scores
    const updatedCA = {
      ...subjectForm?.CA_scores,
      [caType]: inputValue
    };

    // Compute CA_total and total
    const CA_total = Object.values(updatedCA).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const examScore = parseInt(subjectForm?.exam_score) || 0;
    const totalScore = CA_total + examScore;

    // Determine grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";
    }

    setSubjectForm({
      ...subjectForm,
      CA_scores: updatedCA,
      CA_total: String(CA_total),
      total: String(totalScore),
      grade
    });
  };

  // handle EDit Test Scores
  const handleEditTestScoreChange = (e, caType) => {
    const inputRaw = e.target.value;

    // Remove leading zeros
    const inputValue = inputRaw.replace(/^0+(?=\d)/, "");

    // Get the max obtainable for this CA type
    const maxObtainable = obtainablescore?.[0]?.ca?.find((item) => item.ca_type === caType)?.score || 0;

    if (Number(inputValue) > maxObtainable) {
      toast.error(`${caType} cannot exceed ${maxObtainable}`);

      return;
    }

    // Update CA_scores
    const updatedCA_scores = {
      ...editsubjectForm?.CA_scores,
      [caType]: inputValue
    };

    // Calculate CA total and overall total
    const CA_total = Object.values(updatedCA_scores).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const examScore = parseInt(editsubjectForm?.exam_score) || 0;
    const totalScore = CA_total + examScore;

    // Determine grade
    let grade = "";
    const selectedGradingSystem = editsubjectForm?.grading_system
      ? allGradingSystem.find((g) => g?.id === editsubjectForm.grading_system?.id)
      : null;

    if (selectedGradingSystem?.grading) {
      const gradeDetails = selectedGradingSystem.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";
    }

    // Update state
    setEditSubjectForm({
      ...editsubjectForm,
      CA_scores: updatedCA_scores,
      CA_total: String(CA_total),
      total: String(totalScore),
      grade
    });

    setEditCalculatedGrade(grade);
  };

  const getClassTestResult = (aselectedTerm) => {
    // setGetIsLoading(true);
    httprequest
      .get(`${CLASS_TEST_RESULT}${ClassID}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassTestResult(res?.data?.data);
        // setGetIsLoading(false);
      }).catch((err) => {
        // setGetIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getClassExamResult = (aselectedTerm) => {
    httprequest
      .get(`${CLASS_EXAM_RESULT}${ClassID}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassExamResult(res?.data?.data);
      }).catch(() => {
        // toast.error(err?.response?.data?.message);
      });
  };

  // Close Delete Modal
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  // Get A Subject Detail
  const handleGetASubjectById = () => {
    httprequest.get(`${GET_A_SUBJECT}${id}`).then((res) => {
      setASubjectDetail(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  // Handle Get all Grading System
  const handleGetAllGradingSystem = () => {
    httprequest.get(GRADING_SYSTEM).then((res) => {
      setAllGradingSystem(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  // HandleGetClassByID
  const handleGetClassById = () => {
    httprequest.get(`${CLASSES_ENDPOINT}/${ClassID}`).then((res) => {
      setClassDetail(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  // Get Subject result
  const handleGetSubjectResult = async (termId) => {
    setIsPageFetching(true);
    try {
      const res = await httprequest.get(`${GET_SUBJECT_GRADES}${id}/${class_id?.classId}?term_id=${termId}`);
      setIsPageFetching(false);
      setClassGrades(res?.data?.data);
      setSearchResult(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message);
    }
  };

  // Create Add Student Result
  const handlePostStudentResult = () => {
    if (studentResultValidator.allValid()) {
      setResultCreating(true);
      httprequest.post(GET_SUBJECT_GRADES, { ...subjectForm, term_id: aselectedTerm }).then((res) => {
        setResultCreating(false);
        toast.success(res?.data?.message);
        handleGetSubjectResult(aselectedTerm);
        handleCloseAddResultModal();
      }).catch((err) => {
        setResultCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showStudentResultValidator(true);
    }
  };

  // EDit Add Student Result
  const handleEditStudentResult = () => {
    if (editstudentResultValidator.allValid()) {
      setResultEditing(true);
      httprequest.patch(`${GET_SUBJECT_GRADES}${currentRow?.id}`, editsubjectForm).then((res) => {
        setResultEditing(false);
        toast.success(res?.data?.message);
        handleGetSubjectResult(aselectedTerm);
        handleCloseEditResultModal();
      }).catch((err) => {
        setResultEditing(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEditStudentResultValidator(true);
    }
  };

  // handle Delete Subject Result
  const handleDeleteStudentResult = () => {
    setResultDeleting(true);
    httprequest.delete(`${GET_SUBJECT_GRADES}${currentRow?.id}`).then((res) => {
      setResultDeleting(false);
      toast.success(res?.data?.message);
      handleGetSubjectResult(aselectedTerm);
      handleCloseDeleteModal();
    }).catch((err) => {
      setResultDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleOpenBulkResultModal = () => {
    if (!aselectedTerm) {
      toast.error("Please select a term first");

      return;
    }
    if (!classStudents || classStudents.length === 0) {
      toast.error("No students found in this class");

      return;
    }
    setBulkModalOpen(true);
  };

  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  // Handle Get All Classes
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  // Find Active Term in an Current Session
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // Handles the change event when a new tab is selected
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;
    setASelectedTerm(selectedTermId);
    handleGetSubjectResult(selectedTermId);
    getClassTestResult(selectedTermId);
    getClassExamResult(selectedTermId);
  };

  // Handle Session Change
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
   * Fetches all obtainable scores from the API
   */
  const getAllObtainableScores = () => {
    // setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === active_term_session?.session_id));
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      getClassTestResult(active_term_session.id);
      getClassExamResult(active_term_session.id);
    }
  }, [active_term_session]);

  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  useEffect(() => {
    if (active_term_session?.id) {
      const params = {
        term_id: active_term_session.id
      };
      getAllObtainableScores();
      // setSubjectForm({ ...subjectForm, term_id: active_term_session.id });
      handleGetSubjectResult(params?.term_id);
    }
  }, [active_term_session]);

  // Get All Classes
  const getAllClasses = () => {
    setIsPageFetching(true);
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setIsPageFetching(false);
        setClassData(physicalClasses);
        if (isTeacher) {
          setClassDetail(physicalClasses.find((class_detail) => class_detail?.id === ClassID));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  // Get Students in Class
  const getStudentClass = () => {
    if (ClassID) {
      httprequest.get(`${CLASS_STUDENT_ENDPOINT}?class_id=${ClassID}`).then((res) => {
        setClassStudents(res?.data?.data);
      }).catch((err) => {
        toast.error(err?.response?.data);
      });
    }
  };

  // Get All Subject For A Class
  const getAllSubjectForClass = async (class_id) => {
    try {
      const ENDPOINT = isTeacher ? TEACHER_SUBJECT : CLASS_SUBJECT;
      const res = await httprequest.get(`${ENDPOINT}${class_id}`);
      setAllClassSubject(res?.data?.data);
      if (isTeacher) {
        setASubjectDetail(res?.data?.data.find((get_subject) => get_subject?.subject?.id === id));
      }
    } catch (err) {
      toast.error(err?.response?.data);
    }
  };

  // On mount renders all classes
  useEffect(() => {
    getAllSessions();
    handleGetAllGradingSystem();
  }, []);

  useEffect(() => {
    if (class_id?.classId) {
      getAllSubjectForClass(class_id?.classId);
      getStudentClass();
    }
  }, [class_id?.classId]);

  const handleClassChange = (event, newValue) => {
    setValue(newValue);
    getAllSubjectForClass(value);
  };

  // Handle TextChange
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    // Copy form state
    const updatedForm = { ...subjectForm, [name]: value };

    // Check exam_score validity
    if (name === "exam_score") {
      const maxExam = obtainablescore?.[0]?.examination || 0;

      if (numericValue > maxExam) {
        toast.error(`Exam score cannot exceed ${maxExam}!`);

        // Reset to previous valid value
        updatedForm.exam_score = subjectForm?.exam_score || 0;
      }
    }

    // CA_total and exam_score to calculate the total score
    const caTotal = parseFloat(updatedForm.CA_total) || 0;
    const examScore = parseFloat(updatedForm.exam_score) || 0;

    // Add and check total
    const totalScore = caTotal + examScore;
    updatedForm.total = totalScore;

    if (totalScore > 100) {
      toast.error("Total score cannot exceed 100!");
    }

    // Calculate the grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";

      // Update displayed grade
      setCalculatedGrade(grade);
    }

    updatedForm.grade = grade;

    // Update state
    setSubjectForm(updatedForm);
  };

  // handle EDit InputChange
  const handleEditTextChange = (e) => {
    const { name, value } = e.target;

    // Update the form state
    const updatedForm = { ...editsubjectForm, [name]: value };

    // CA_total and exam_score to calculate the total score
    const caTotal = parseFloat(updatedForm?.CA_total) || 0;
    const examScore = parseFloat(updatedForm?.exam_score) || 0;

    // Update the total score
    updatedForm.total = caTotal + examScore;

    if (updatedForm?.total > 100) {
      toast.error("Total score cannot exceed 100!");
    }

    // Calculate the grade based on the updated total score
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => updatedForm?.total >= grade?.min && updatedForm?.total <= grade.max
      );
      grade = gradeDetails ? gradeDetails?.grade : "";

      // Update the calculated grade
      setEditCalculatedGrade(grade);
    }

    // Update the grade in the form
    updatedForm.grade = grade;

    // Set the updated form state
    setEditSubjectForm(updatedForm);
  };

  // Handle Select Grade system
  const handleGradeChange = (e) => {
    const selectedId = e.target.value;
    if (selectedId === "create_new") {
      navigate("/report/grade-system");

      return;
    }
    const selectedGradingSystem = allGradingSystem.find(
      (gradeSystem) => gradeSystem?.id === selectedId
    );

    setSelectedGrade(selectedGradingSystem);

    if (selectedGradingSystem && subjectForm?.total !== null) {
      const gradeDetails = selectedGradingSystem.grading.find(
        (grade) => subjectForm.total >= grade.min && subjectForm.total <= grade.max
      );

      if (gradeDetails) {
        setCalculatedGrade(gradeDetails?.grade);
        // Update the grade in the subjectForm state
        setSubjectForm((prevForm) => ({
          ...prevForm,
          grade: gradeDetails?.grade,
          grading_system_id: selectedId
        }));
      } else {
        toast.error("Total does not fall within any grade range.");
        // Optionally clear the grade if no range matches
        setSubjectForm((prevForm) => ({
          ...prevForm,
          grade: "",
          grading_system_id: ""
        }));
      }
    }
  };

  // Handle Select Grade System for Edit Modal
  const handleEditGradeChange = (e) => {
    const selectedId = e.target.value || editsubjectForm?.grading_system?.id;
    if (selectedId === "create_new") {
      navigate("/report/grade-system");

      return;
    }
    const selectedGradingSystem = allGradingSystem.find(
      (gradeSystem) => gradeSystem?.id === selectedId
    );

    setEditSelectedGrade(selectedGradingSystem);

    if (selectedGradingSystem && editsubjectForm?.total !== null) {
      const gradeDetails = selectedGradingSystem.grading.find(
        (grade) => editsubjectForm.total >= grade.min && editsubjectForm.total <= grade.max
      );

      if (gradeDetails) {
        setEditCalculatedGrade(gradeDetails?.grade);
        // Update the grade in the subjectForm state
        setEditSubjectForm((prevForm) => ({
          ...prevForm,
          grade: gradeDetails?.grade,
          grading_system: selectedId
        }));
      } else {
        toast.error("Total does not fall within any grade range.");
        // Optionally clear the grade if no range matches
        setEditSubjectForm((prevForm) => ({
          ...prevForm,
          grade: "",
          grading_system: ""
        }));
      }
    }
  };

  // Get all unique CA types from data
  const uniqueCAKeys = Array.from(
    new Set(
      classGrades.flatMap(item => Object.keys(item?.CA_scores || {}))
    )
  );

  const dynamicCAColumns = uniqueCAKeys?.map((key) => ({
    name: key,
    selector: (row) => (
      <>
        {mobile && <p className="mobile-styling">{key}</p>}
        {row?.CA_scores?.[key] !== undefined ? row?.CA_scores[key] : "--/--"}
      </>
    ),
    sortable: true
  }));

  const columns = [
    {
      name: "Student Names",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Student Names</p>}
          {`${row?.student?.first_name} ${row?.student?.last_name}` || "--/--"}
        </>
      )
    },
    ...dynamicCAColumns,
    {
      name: "CA Score",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">CA Score</p>}
          {row?.CA_total !== undefined ? parseInt(row.CA_total) : "--/--"}
        </>
      )
    },
    {
      name: "Exam Score",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Exam Score</p>}
          {parseInt(row?.exam_score) || "--/--"}
        </>
      )
    },
    {
      name: "Total",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Total</p>}
          {parseInt(row?.total) || "--/--"}
        </>
      )
    },
    {
      name: "Grade",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Grade</p>}
          {row?.grade || "--/--"}
        </>
      )
    },
    {
      name: "Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date</p>}
          {row?.created_at.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon"
            onClick={() => handleEditResultModal(row)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // Handle Filter for All School Examination
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    if (value.includes("-")) {
      // Extract the min and max scores from the value
      const [min, max] = value.split("-").map(Number);

      // Filter data based on the score range
      const filteredByRange = classGrades?.filter((data) => {
        const totalScore = parseFloat(data?.total || "0");

        return totalScore >= min && totalScore <= max;
      });

      setSearchResult(filteredByRange);
    } else {
      // Reset to all data if no valid range is selected
      setSearchResult(classGrades);
    }
  };

  // --| Filter Student table using name, email and class
  const handleSearchStudentResult = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");

    const filteredByScore = filterStatus
      ? classGrades.filter((data) => data.total.toLowerCase() === filterStatus.toLowerCase())
      : classGrades;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByScore?.filter((data) => valArray?.every(
      (word) => data?.student?.first_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.total
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.CA_total
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.last_name
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.exam_score
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.grade
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    if (classesData?.length > 0 && !value) {
      const class_value = classesData[0]?.id;
      setValue(class_value);
    }
  }, [classesData]);

  useEffect(() => {
    getAllClasses();
    if (!isTeacher) {
      handleGetClassById();
      handleGetASubjectById();
    }
  }, []);

  const filteredResults = classTestResult.filter(item => item.student?.id === subjectForm?.student_id &&
    item.subject?.id === subjectForm?.subject_id
  );

  const handleAutoCAChange = (e) => {
    const isChecked = e.target.checked;
    setAutoCA(isChecked);

    if (isChecked && filteredResults.length > 0) {
      const selectedResult = filteredResults[0];
      const updatedCAScores = { ...selectedResult.ca_scores };

      const totalCA = Object.values(updatedCAScores).reduce(
        (sum, score) => sum + (Number(score) || 0),
        0
      );

      setSubjectForm((prev) => ({
        ...prev,
        CA_scores: updatedCAScores,
        CA_total: String(totalCA),
        total: String(totalCA),
        grade_type: "auto"
      }));
    } else {
    // Reset on uncheck
      setSubjectForm((prev) => ({
        ...prev,
        CA_scores: {},
        CA_total: "",
        total: "",
        exam_score: 0,
        grade_type: "manual"
      }));
    }
  };

  return (
    <Layout children={
      <div>
        <div className="breadcrumb-container">
          {isTeacher ? (
            <div>
              <BreadCrumb
                link_one="/mysubjects"
                link_one_name="My Subjects"
                active={aSubjectDetail?.subject?.name}
                description="See and Add academic result of each student taking this subject"
              />
            </div>
          ) : (
            <div>
              <BreadCrumb
                link_one="/class-activities/subjects"
                link_one_name="My Subjects"
                active={aSubjectDetail?.name}
                description="See academic result of each student taking this subject"
              />
            </div>
          )}
          <div className="flex gap-10">
            {/* <Button
              onClick={handleAddSubjectModal}
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              buttonName="Add Student Result"
            /> */}
            <Button
              onClick={handleOpenBulkResultModal}
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Add Student Result"
            />
          </div>
        </div>
        <div className="page-content">
          <div className="action_div flex-wrap-items-600">
            <div className={classes.contentpadding}>
              <ButtonCount func={() => navigate("")} title={`Results in ${classDetail?.class_name}`} count={classGrades?.length} />
            </div>
            <div className="flex gap-10 align-items-end margin-top-5 margin-bottom-14">
              <div className="margin-bottom-10">
                {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                  : <Icon onClick={() => handleGetSubjectResult(active_term_session?.id)} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
              </div>
              <div>
                {activeSession?.id && (
                  <SelectGroup
                    children={
                      <select
                        defaultValue={activeSession?.id}
                        onChange={handleSessionChange}
                        name="session"
                      >
                        <option value="">---Select---</option>
                        {allSessions?.map((sesh) => {
                          return (
                            <option key={sesh?.id} value={sesh?.id}>
                              {sesh?.session}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                )}
              </div>
              <div>
                {active_term_session?.id && (
                  <SelectGroup
                    children={
                      <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                        <option value="">---Select---</option>
                        {selectedSessionTerms?.map((data) => {
                          return (
                            <option key={data?.id} value={data?.id}>
                              {data?.term}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                )}
              </div>
            </div>
          </div>
          {isPageFetching ? (
            <PageLoader />
          ) : classGrades.length > 0 ? (
            <Table
              data={searchResult}
              columns={columns}
              subHeader={true}
              pagination
              subHeaderComponent={
                <div className="action_div">
                  <TableSearch
                    placeholder="Search here..."
                    searchTableFunc={handleSearchStudentResult}
                  />
                  <div>
                    <SelectGroup
                      children={
                        <select name="type" onChange={handleFilterChange}>
                          <option value="">-- Sort By--</option>
                          <option value="90-100">90 - 100</option>
                          <option value="80-89">80 - 89</option>
                          <option value="70-79">70 - 79</option>
                          <option value="60-69">60 - 69</option>
                          <option value="50-59">50 - 59</option>
                          <option value="40-49">40 - 49</option>
                          <option value="30-39">30 - 39</option>
                          <option value="20-29">20 - 29</option>
                        </select>
                      }
                    />
                  </div>
                </div>}
            />
          ) : (
            <div className={classes.notfound}>
              <NotFounditem
                img={nosearch}
                title="No Result Found"
                subtitle="No Subject Result has been added to the list."
              />
            </div>
          )}
          <div className="flex justify-items-space Blockspacing">
            <div className={classes.contentpadding}>
              <ButtonCount func={() => navigate("")} title={`Students in ${classDetail?.class_name}`} count={subjectStudents?.length} />
            </div>
            <div className={classes.employee}>
              <p>Class Teacher: </p>
              <h4>{`${classDetail?.class_teacher?.last_name} ${classDetail?.class_teacher?.first_name}` || "---/---"}</h4>
            </div>
          </div>
        </div>
        {/* Delete Modal */}
        <Modal
          title={`Delete ${currentRow?.student?.last_name} ${currentRow?.student?.first_name} Result`}
          subtitle={
            <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.student?.last_name} {currentRow?.student?.first_name}</span>Result? Deleting is a permanent action
            </div>}
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" onClick={handleDeleteStudentResult} isLoading={resultDeleting} buttonName="Delete Result" buttonSize="full" color="btndefault" />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* Add Results */}
        <Modal
          title="Add Result"
          subtitle={
            <div>
                Manually add your student’s result.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Class"
                    required
                    children={
                      <select disabled value={ClassID} name="class_id" onChange={handleClassChange}>
                        <option value="">--- Select ---</option>
                        {classesData?.map((class_id) => {
                          return (
                            <option key={class_id.id} value={class_id?.id}>
                              {class_id?.class_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Class", subjectForm?.class_id, "required")}
                </Grid>
                {isTeacher ? (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Subject"
                      required
                      children={
                        <select disabled value={id} name="subject_id" onChange={handleTextChange}>
                          <option value="">--- Select ---</option>
                          {allClassSubject?.map((subject) => {
                            return (
                              <option key={subject.subject?.id} value={subject?.subject?.id}>
                                {subject?.subject?.name}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Subject", subjectForm?.subject_id, "required")}
                  </Grid>
                ) : (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Subject"
                      required
                      children={
                        <select disabled value={id} name="subject_id" onChange={handleTextChange}>
                          <option value="">--- Select ---</option>
                          {allClassSubject?.map((subject) => {
                            return (
                              <option key={subject.subject_id} value={subject?.subject_id}>
                                {subject?.subject_name}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {studentResultValidator.message("Subject", subjectForm?.subject_id, "required")}
                  </Grid>
                )}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Students"
                    required
                    children={
                      <select name="student_id" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {classStudents?.map((student) => {
                          return (
                            <option key={student?.student_id} value={student?.student_id}>
                              {`${student?.last_name || ""} ${student?.first_name || ""}`.trim()}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Student", subjectForm?.student_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label>
                    <input
                      type="checkbox"
                      disabled={filteredResults.length === 0}
                      onChange={handleAutoCAChange}
                    />
                        Add Score from CA Test
                  </label>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    {autoCA ? (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => {
                          const existingValue = subjectForm?.CA_scores?.[item.ca_type];

                          return (
                            <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                label={item?.ca_type}
                                margin="normal"
                                required
                                placeHolder="Enter score"
                                inputType="number"
                                value={existingValue ?? 0}
                                onChange={(e) => handleTestScoreChange(e, item.ca_type)}
                              />
                              {/* {
                                studentResultValidator.message(
                                  item?.ca_type,
                                  subjectForm?.CA_scores?.[item?.ca_type],
                                  "required"
                                )} */}
                              {caErrors[item?.ca_type] && (
                                <p className={classes.printError}>
                                  {caErrors[item?.ca_type]}
                                </p>
                              )}
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => (
                          <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                            <InputGroup
                              label={item?.ca_type}
                              margin="normal"
                              required
                              placeHolder="Enter score"
                              inputType="number"
                              onChange={(e) => handleTestScoreChange(e, item?.ca_type)}
                              // value={subjectForm?.CA_scores?.[item?.ca_type] ?? 0}
                            />
                            {/* {studentResultValidator.message(
                              item?.ca_type,
                              subjectForm?.CA_scores?.[item?.ca_type],
                              "required"
                            )} */}
                            {caErrors[item?.ca_type] && (
                              <p className={classes.printError}>
                                {caErrors[item?.ca_type]}
                              </p>
                            )}
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Total CA Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="CA_total"
                    value={subjectForm?.CA_total}
                    disabled
                  />
                  {studentResultValidator.message("CA Total", subjectForm?.CA_total, "required")}
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="exam_score"
                    onChange={handleTextChange}
                  />
                  {/* {studentResultValidator.message("Exam Score", subjectForm?.exam_score, "required")} */}
                </Grid>
                <Grid item lg={4} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Total Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="total"
                    value={subjectForm?.total || 0}
                    disabled
                  />
                  {studentResultValidator.message("Total Score", subjectForm?.total, "required")}
                </Grid>
                <Grid item lg={9} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade System"
                    required
                    children={
                      <select name="grading_system_id" onChange={handleGradeChange}>
                        <option value="">--- Select ---</option>
                        {allGradingSystem?.map((grade_system) => {
                          return (
                            <option key={grade_system?.id} value={grade_system?.id}>
                              {grade_system?.title}
                            </option>
                          );
                        })}
                        <option value="create_new" style={{ color: "#155EEF", fontWeight: 500 }}>
                          + Create Grading System
                        </option>
                      </select>
                    }
                  />
                  {studentResultValidator.message("Grading System", subjectForm?.grading_system_id, "required")}
                </Grid>
                <Grid item lg={3} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade"
                    required
                    children={
                      <select disabled value={calculatedGrade || ""} name="grade" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {selectedGrade?.grading?.map((grade_type) => {
                          return (
                            <option key={grade_type?.grade} value={grade_type?.grade}>
                              {grade_type?.grade}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Grade", subjectForm?.grade, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Add Result"
                  onClick={handlePostStudentResult}
                  isLoading={resultCreating}
                />
              </div>
            </>
          }
          isopen={addsubjectModal}
          closeModal={handleCloseAddResultModal}
        />
        {/* Edit Results */}
        <Modal
          title={`Edit ${currentRow?.student?.last_name} ${currentRow?.student?.first_name} Result`}
          subtitle={
            <div>
                Manually Edit your student’s result.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Class"
                    required
                    children={
                      <select disabled value={ClassID} name="class_id" onChange={handleClassChange}>
                        <option value="">--- Select ---</option>
                        {classesData?.map((class_id) => {
                          return (
                            <option key={class_id.id} value={class_id?.id}>
                              {class_id?.class_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {editstudentResultValidator.message("Class", editsubjectForm?.class_id, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  {isTeacher ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup
                        label="Subject"
                        required
                        children={
                          <select disabled value={id} name="subject_id" onChange={handleTextChange}>
                            <option value="">--- Select ---</option>
                            {allClassSubject?.map((subject) => {
                              return (
                                <option key={subject.subject?.id} value={subject?.subject?.id}>
                                  {subject?.subject?.name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {editstudentResultValidator.message("Subject", editsubjectForm?.subject_id, "required")}
                    </Grid>
                  ) : (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup
                        label="Subject"
                        required
                        children={
                          <select disabled value={id} name="subject_id" onChange={handleTextChange}>
                            <option value="">--- Select ---</option>
                            {allClassSubject?.map((subject) => {
                              return (
                                <option key={subject.subject_id} value={subject?.subject_id}>
                                  {subject?.subject_name}
                                </option>
                              );
                            })}
                          </select>
                        }
                      />
                      {editstudentResultValidator.message("Subject", editsubjectForm?.subject_id, "required")}
                    </Grid>
                  )}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Students"
                    required
                    children={
                      <select value={editsubjectForm?.student_id} disabled name="student_id" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {subjectStudents?.map((student) => {
                          return (
                            <option key={student?.student_id} value={student?.student_id}>
                              {`${student?.last_name} ${student?.first_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {editstudentResultValidator.message("Student", editsubjectForm?.student_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    {Object.entries(editsubjectForm?.CA_scores || {}).map(([key, value], index) => (
                      <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                        <InputGroup
                          label={key}
                          margin="normal"
                          required
                          placeHolder="Enter score"
                          inputType="text"
                          onChange={(e) => handleEditTestScoreChange(e, key)}
                          defaultValue={value}
                        />
                        {editstudentResultValidator.message(
                          key,
                          editsubjectForm?.CA_scores?.[key],
                          "required"
                        )}
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Total CA Score"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="CA_total"
                    value={editsubjectForm?.CA_total}
                    disabled
                  />
                  {editstudentResultValidator.message("CA Total", editsubjectForm?.CA_total, "required")}
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Score"
                    margin="normal"
                    inputType="text"
                    required
                    defaultValue={editsubjectForm?.exam_score}
                    inputName="exam_score"
                    onChange={handleEditTextChange}
                  />
                  {editstudentResultValidator.message("Exam Score", editsubjectForm?.exam_score, "required")}
                </Grid>
                <Grid item lg={4} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Total Score"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="total"
                    value={editsubjectForm?.total || 0}
                    disabled
                  />
                  {editstudentResultValidator.message("Total Score", editsubjectForm?.total, "required")}
                </Grid>
                <Grid item lg={9} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade System"
                    required
                    children={
                      <select value={editsubjectForm?.grading_system?.id} name="grading_system" onChange={handleEditGradeChange}>
                        <option value="">--- Select ---</option>
                        {allGradingSystem?.map((grade_system) => {
                          return (
                            <option key={grade_system?.id} value={grade_system?.id}>
                              {grade_system?.title}
                            </option>
                          );
                        })}
                        <option value="create_new" style={{ color: "#155EEF", fontWeight: 500 }}>
                          + Create Grading System
                        </option>
                      </select>
                    }
                  />
                  {editstudentResultValidator.message("Grade System", editsubjectForm?.grading_system, "required")}
                </Grid>
                <Grid item lg={3} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade"
                    required
                    children={
                      <select disabled value={editcalculatedGrade || editsubjectForm?.grade} name="grade">
                        <option value="">--- Select ---</option>
                        {editselectedGrade?.grading?.map((grade_type) => {
                          return (
                            <option key={grade_type?.grade} value={grade_type?.grade}>
                              {grade_type?.grade}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {editstudentResultValidator.message("Grade", editsubjectForm?.grade, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Edit Result"
                  onClick={handleEditStudentResult}
                  isLoading={resultEditing}
                />
              </div>
            </>
          }
          isopen={editResultModal}
          closeModal={handleCloseEditResultModal}
        />
        {/* <ToastContainer /> */}
        <BulkSingleSubjectResultEntry
          open={bulkModalOpen}
          onClose={() => setBulkModalOpen(false)}
          classId={ClassID}
          className={classDetail?.class_name}
          subject={aSubjectDetail}
          termId={aselectedTerm}
          termName={selectedSessionTerms?.find(term => term.id === aselectedTerm)?.term}
          session={activeSession?.session}
          students={classStudents}
          obtainableScores={obtainablescore}
          gradingSystems={allGradingSystem}
          existingResults={classGrades}
          classTestResults={classTestResult}
          classExamResults={classExamResult}
          onSave={async (data) => {
            try {
              setBulkLoading(true);
              const res = await httprequest.post(GET_SUBJECT_GRADES, data);
              toast.success(res?.data?.message);
              handleGetSubjectResult(aselectedTerm);
              setBulkModalOpen(false);
            } catch (err) {
              toast.error(err?.response?.data?.message);
            } finally {
              setBulkLoading(false);
            }
          }}
          isLoading={bulkLoading}
        />
      </div>
    }
    />
  );
};

export default SubjectResultDetails;
